import { createApp, h } from 'vue'
import { injectToasted } from '../src/utils/vue-toasted/inject_toasted'
import AlertDeactivatedPoc from '../src/pages/admin/components/alert_deactivated_poc.vue'

export const app = createApp({
  render: () => h(AlertDeactivatedPoc)
})

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById(
    'update-poc-live-portal-mount'
  ) as HTMLElement

  if (!el) return

  injectToasted(app)

  app.mount(el)
})
